// ─── Pestaña Cohortes (puro, con test) ──────────────────────────────────────
// El selector de período de ingreso listaba los períodos en el orden de sus ids
// (al azar para quien lo mira): con 129 períodos importados no había forma de
// encontrar uno. Ahora, del más nuevo al más viejo.

export interface CohortTermOption {
  id: string;
  name: string;
  /** `YYYY-MM-DD`; los que no tienen fecha van al final, por nombre. */
  startDate?: string;
}

export function sortTermsNewestFirst(terms: readonly CohortTermOption[]): CohortTermOption[] {
  return [...terms].sort((a, b) => {
    if (a.startDate && b.startDate && a.startDate !== b.startDate) {
      return b.startDate.localeCompare(a.startDate);
    }
    if (!!a.startDate !== !!b.startDate) return a.startDate ? -1 : 1;
    return a.name.localeCompare(b.name);
  });
}

/** Una fecha guardada como `YYYY-MM-DD`, Timestamp o Date → `YYYY-MM-DD`. */
export function ymdOf(value: unknown): string | undefined {
  if (typeof value === 'string' && /^\d{4}-\d{2}-\d{2}/.test(value)) return value.slice(0, 10);
  const d =
    value && typeof (value as { toDate?: unknown }).toDate === 'function'
      ? (value as { toDate(): Date }).toDate()
      : value instanceof Date
        ? value
        : null;
  return d && !Number.isNaN(d.getTime()) ? d.toISOString().slice(0, 10) : undefined;
}

/** Nombre a mostrar de una persona (como siempre: `name`, o nombre y apellido). */
export function personDisplayName(id: string, data: Record<string, unknown>): string {
  return (
    (data['name'] as string | undefined) ||
    [data['firstName'], data['lastName']].filter(Boolean).join(' ') ||
    id
  );
}
